/* eslint-disable camelcase */
import getCart from './getCart';
import updateCartCount from './updateCartCount';


// Accepts an array of items: [{ id, quantity, selling_plan }]
const addToCart = async (itemsArray) => {
  const items = {
    items: itemsArray.map(item => {
      const payload = {
        id: item.id,
        quantity: item.quantity
      };
      if (item.sellingPlan) {
        payload.selling_plan = item.sellingPlan;
      }
      return payload;
    })
  };

  try {
    const atc = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(items)
    });
    const cart = await getCart();
    updateCartCount(cart.item_count);
    return await atc.json();
  } catch (err) {
    console.error('Add to cart error:', err);
  }
};

export default addToCart;
